import React from 'react';

const MaterialResult = ({ materials }) => {
  return (
    <div className="mt-6">
      <h3 className="font-semibold mb-2">📦 Required Materials</h3>
      <table className="w-full border text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-2">Material</th>
            <th className="border p-2">Quantity</th>
            <th className="border p-2">Unit</th>
          </tr>
        </thead>
        <tbody>
          {materials.map((m, index) => (
            <tr key={index}>
              <td className="border p-2">{m.material_name}</td>
              <td className="border p-2">
                {isNaN(m.required_quantity) ? '0' : Math.ceil(m.required_quantity)}
              </td>
              <td className="border p-2">{m.material_unit}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MaterialResult;
